<template lang="pug">
div
  .mb-2
    select.form-control(v-model="bankId" @change="selectBank")
      option(selected value="") {{ $t('ui.please_select_bank') }}
      template(v-if="bankList.length > 0")
        option(v-for="bank in bankList" :value="bank.aa") {{bank.bank_name}} ({{bank.bank_acc_no}})
  template(v-if="bankList.length > 0 && bankId !==''")
    .mb-2
      label.col-form-label {{ $t("ui.bank_name") }} :
      input.form-control.input-disabled(type="text" :placeholder="bankName" disabled)
    .mb-2
      label.col-form-label {{ $t("ui.bank_accname") }} :
      input.form-control.input-disabled(type="text" :placeholder="bankHolder" disabled)
    .mb-2
      label.col-form-label {{ $t("ui.bank_accno") }} :
      input.form-control.input-disabled(type="text" :placeholder="bankNo" disabled)
    //- .mb-2
      label.col-form-label {{ $t("ui.status") }} :
        span.text-uppercase(:class="getColor(bankStatus)") &nbsp;{{getText(bankStatus)}}
  activeDisplay(:displayType="'BANK'")
</template>
<script>
import activeDisplay from '@/component/_activeList.vue'
export default {
  components:{
    activeDisplay
  },
  data(){
    return{
      bankList: [],
      bankId: "",
      bankName: "",
      bankNo: "",
      bankHolder: "",
      bankStatus: ""
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  created(){
    this.getMemberBankList()
  },
  methods:{
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              response.data.filter(x=> x.status===true).forEach((y, index) => {
                y.aa = "b-" + index
                this.bankList.push(y)
              })
              // for(var i = 0; i< response.data.length; i++){
              //   response.data[i].aa = "b-" + i
              // }
							// this.bankList = response.data
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    selectBank(){
      this.bankList.filter(x => x.aa === this.bankId).forEach(y => {
        this.bankHolder = y.bank_acc_holder
        this.bankNo = y.bank_acc_no
        this.bankName = y.bank_name
        this.bankStatus = y.status

      })
    },
    getText(status){
      if(status === true){
        var tag = "active"
      }else{
        var tag = "inactive"
      }
      return this.$t(tag);
    },
    getColor(status){
      if(status === true){
        return "text-success"
      }else{
        return "text-danger"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// select {
//   -webkit-appearance: listbox !important;
// }
</style>